export var CircuitBreakerState;
(function (CircuitBreakerState) {
    CircuitBreakerState[CircuitBreakerState["CLOSED"] = 0] = "CLOSED";
    CircuitBreakerState[CircuitBreakerState["OPEN"] = 1] = "OPEN";
    CircuitBreakerState[CircuitBreakerState["HALF_OPEN"] = 2] = "HALF_OPEN";
})(CircuitBreakerState = CircuitBreakerState || (CircuitBreakerState = {}));
//# sourceMappingURL=types.js.map